import React from "react";
import SuspenseLoadingSpinner from "./SuspenseLoadingSpinner";
import LoadingText from "./SuspenseLoadingText";
import {
  Settings,
  Users,
  Database,
  Shield,
  CheckCircle,
  GraduationCap,
} from "lucide-react";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/Logo/QCBT.png";
import { ISTESTCENTREADMINPANEL } from "../../environment";

interface SuspenseLoaderProps {
  progress?: number;
  stage?: number;
  loading: boolean;
}

const examStages = [
  { message: "Initializing exam configuration system", icon: GraduationCap },
  { message: "Loading candidate data and permissions", icon: Users },
  { message: "Preparing question bank and analytics", icon: Database },
  { message: "Configuring proctoring services", icon: Shield },
  { message: "Ready for exam administration", icon: CheckCircle },
];

const SuspenseLoader: React.FC<SuspenseLoaderProps> = ({
  progress = 0,
  stage = 0,
  loading,
}) => {
  const currentStage = examStages[Math.min(stage, examStages.length - 1)];
  const Icon = currentStage.icon;
  const location = useLocation();

  if (!loading) return <></>;

  return (
    <div
      className={`${
        location.pathname.split("/").filter(Boolean).length >= 2
          ? ` ${
              ISTESTCENTREADMINPANEL == "OFFLINE"
                ? "w-screen left-0 top-0"
                : " w-[85vw] left-[15%] top-[8%]"
            } `
          : "w-screen left-0 top-0"
      } min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 fixed  z-[9999] flex flex-col items-center justify-center`}
    >
      <div>
        <div>
          <div className="relative flex justify-center items-center">
            <div className="absolute animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-blue-500" />
            <img src={Logo} className="rounded-full h-24 w-24" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuspenseLoader;
